__turbopack_context__.v({
  "empty-message": "WhatsNewList-module-scss-module__zU2Qra__empty-message",
  "item": "WhatsNewList-module-scss-module__zU2Qra__item",
  "list": "WhatsNewList-module-scss-module__zU2Qra__list",
});
